<div *ngFor="let slide of item.slides"><img [src]="slide.url"/></div>
